import { flow, isNil } from 'lodash';
import { isEqual, omitBy, pick, property, values } from 'lodash/fp';

const fieldsNames = ['action', 'trigger', 'answer', 'points'];

const isPostLogicRuleFilled = flow([
  pick(fieldsNames),
  omitBy(val => isNil(val) || val === ''),
  values,
  property('length'),
  isEqual(fieldsNames.length),
]);

export default isPostLogicRuleFilled;
